'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';

export interface ToggleFavoriteResult {
  isFavorite: boolean;
  favoritedAt: string | null;
}

export async function toggleFavorite(bookId: string): Promise<ActionResult<ToggleFavoriteResult>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };

    const { getIllustrationRepository } = await import('@/contexts/illustrations/repositories');
    const repo = getIllustrationRepository();
    const result = await repo.toggleFavorite(bookId, familyId);

    return { success: true, data: result };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('toggleFavorite', e) };
  }
}
